import React, { useState, useContext, useEffect } from "react";
import { ScreenSizeContext } from "../context/ScreenSizeContext";
import MenuItem from '@material-ui/core/MenuItem';

import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import LocationCityIcon from '@material-ui/icons/LocationCity';
import EditIcon from "@material-ui/icons/Edit";
import EmailIcon from "@material-ui/icons/Mail";
import PhoneIcon from "@material-ui/icons/Phone";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";


const sites = [
  {
    location: 'Göteborg',
    label: 'Göteborg',
  },
  {
    location: 'Linköping',
    label: 'Linköping',
  },
];

const UserInfo = (props) => {
  const { onMobile } = useContext(ScreenSizeContext);
  const privateResume = props.privateResume;

  const [userInfo, setUserInfo] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    officeLocation: ""
  });

  const [editing, setEditing] = useState(false);

  useEffect(() => {
    if (editing) return;

    setUserInfo({
      firstname: props.userInfo.firstname || "",
      lastname: props.userInfo.lastname || "",
      email: props.userInfo.email || "",
      phone: props.userInfo.phone || "",
      officeLocation: props.userInfo.officeLocation || "",
    });
  }, [props.userInfo, editing]);

  const onSubmit = (e) => {
    e.preventDefault();
    props
      .onSaveUserInfo(userInfo)
      .then(() => {
        setEditing(false);
      })
      .catch(() => {});
  };

  const onChange = (e) => {
    setUserInfo({ ...userInfo, [e.target.name]: e.target.value });
  };

  return (
    <div
      style={{
        margin: !onMobile ? "0px 20px" : "0px",
        width: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          {!editing && (
            <h2
              style={{
                padding: "10px 10px 0px 0px",
                margin: "0px",
                textAlign: "left",
              }}
            >
              {userInfo.firstname && userInfo.lastname
                ? `${userInfo.firstname} ${userInfo.lastname}`
                : "No name..."}
            </h2>
          )}
          {!editing && !onMobile && (
            <IconButton
              onClick={() => setEditing(true)}
              variant="outlined"
              color="primary"
            >
              <EditIcon />
            </IconButton>
          )}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: onMobile ? "column" : "row",
          }}
        >
          {props.showPrivateResumeToggle ? (
            <FormControlLabel
              control={
                <Checkbox
                  checked={privateResume}
                  onChange={() =>
                    props.onChangePrivateResumeStatus(!privateResume)
                  }
                  name="privateResume"
                  value={privateResume}
                  color="primary"
                />
              }
              label="Make CV private"
              style={{
                padding: "0px",
                margin: !onMobile ? "0px 20px" : "0px 0px 0px 0px",
                alignSelf: onMobile ? "flex-end" : "",
              }}
              disabled={!props.canTogglePrivateResume}
            />
          ) : (
            <></>
          )}

        </div>
      </div>
      <div style={{ display: "flex", alignItems: "flex-end" }}>
        {!editing ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              paddingRight: "20px",
            }}
          >
            <div
              style={{
                display: "flex",
                marginTop: "5px",
                alignItems: "center",
              }}
            >
              <EmailIcon fontSize="small" />
              <p style={{ margin: "2px 5px" }}>{userInfo.email === "" ? "No email..." : userInfo.email}</p>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <PhoneIcon fontSize="small" />
              <p style={{ margin: "2px 5px" }}>{userInfo.phone === "" ? "No phone number..." : userInfo.phone}</p>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <LocationCityIcon fontSize="small" />
              <p style={{ margin: "2px 5px" }}>{userInfo.officeLocation ? userInfo.officeLocation : "No location..."}</p>

            </div>
          </div>
        ) : (
          <form
            onSubmit={onSubmit}
            style={{ margin: "15px 0px 16px 0px", width: "100%" }}
          >
            <div
              style={{
                display: "flex",
                margin: "0px",
                flexDirection: onMobile ? "column" : "row",
              }}
            >
              <TextField
                type="text"
                name="firstname"
                label="Firstname"
                value={userInfo.firstname}
                onChange={onChange}
                className="form-cotrol"
                variant="outlined"
                placeholder="Enter a title"
                style={{
                  margin: onMobile ? "10px 0px" : "0px 10px 0px 0px",
                  width: onMobile ? "100%" : "25%",
                }}
              />
              <TextField
                type="text"
                name="lastname"
                label="Lastname"
                value={userInfo.lastname}
                onChange={onChange}
                className="form-cotrol"
                variant="outlined"
                placeholder="Enter a title"
                style={{
                  margin: onMobile ? "10px 0px" : "0px 10px 0px 0px",
                  width: onMobile ? "100%" : "25%",
                }}
              />
              <TextField
                type="email"
                name="email"
                label="Email"
                value={userInfo.email}
                onChange={onChange}
                className="form-cotrol"
                variant="outlined"
                placeholder="Enter a title"
                style={{
                  margin: onMobile ? "10px 0px" : "0px 10px 0px 0px",
                  width: onMobile ? "100%" : "25%",
                }}
              />
              <TextField
                type="text"
                name="phone"
                label="Phone number"
                value={userInfo.phone}
                onChange={onChange}
                className="form-cotrol"
                variant="outlined"
                placeholder="Enter a title"
                style={{
                  margin: onMobile ? "10px 0px" : "0px 10px 0px 0px",
                  width: onMobile ? "100%" : "25%",
                }}
              />
              <div>
      <TextField
        id="outlined-select-currency"
        select
        label="Site Location"
        name="officeLocation"
        value={userInfo.officeLocation ? userInfo.officeLocation : ""}
        style={{width: "20ch"}}
        onChange={onChange}
        variant="outlined"
      >
        {sites.map((site) => (
          <MenuItem  key={site.location} value={site.location}>
            {site.label}
          </MenuItem>
        ))}
      </TextField>
      </div>
              {onMobile && (
                <div style={{ display: "flex" }}>
                  <Button
                    type="submit"
                    variant="outlined"
                    color="primary"
                    style={{ margin: "0px 0px 0px 0px", width: "48.5%" }}
                  >
                    Save
                  </Button>
                  <Button
                    onClick={() => {
                      setEditing(false);
                    }}
                    variant="outlined"
                    color="secondary"
                    style={{ margin: "0px 0px 0px 5%", width: "48.5%" }}
                  >
                    Cancel
                  </Button>
                </div>
              )}
              {!onMobile && (
                <>
                  <Button
                    type="submit"
                    variant="outlined"
                    color="primary"
                    style={{ margin: "0px 5px 0px 5px", width: "12.5%" }}
                  >
                    Save
                  </Button>
                  <Button
                    onClick={() => {
                      setEditing(false);
                    }}
                    variant="outlined"
                    color="secondary"
                    style={{ margin: "0px 5px 0px 5px", width: "12.5%" }}
                  >
                    Cancel
                  </Button>
                </>
              )}
            </div>
          </form>
        )}
        {!editing && onMobile && (
          <IconButton
            onClick={() => setEditing(true)}
            variant="outlined"
            color="primary"
            style={{ position: "absolute", right: "30px" }}
          >
            <EditIcon />
          </IconButton>
        )}
      </div>
    </div>
  );
};

export default UserInfo;
